import { render, staticRenderFns } from "./minus_button.vue?vue&type=template&id=89d81422"
import script from "./minus_button.vue?vue&type=script&lang=js"
export * from "./minus_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports